export const METRIC_DEFINITIONS = [
  { key: 'compliance', title: 'Соответствие метод.рекомендациям', detailColor: '#5470c6' },
  { key: 'speed', title: 'Скорость оказания МП', detailColor: '#91cc75' },
  { key: 'quality', title: 'Качество оказания МП', detailColor: '#fac858' },
  { key: 'patientCentricity', title: 'Пациентоцентричность', detailColor: '#ee6666' },
  { key: 'digitalMaturity', title: 'Цифровая зрелость', detailColor: '#73c0de' },
];

export const METRIC_LABELS = METRIC_DEFINITIONS.reduce((acc, item) => {
  acc[item.key] = item.title;
  return acc;
}, {});
